var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPacketLoss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4756 6.33294H7.85677C7.01522 6.33294 6.33301 7.01515 6.33301 7.8567V15.4755C6.33301 16.3171 7.01522 16.9993 7.85677 16.9993H15.4756C16.3171 16.9993 16.9993 16.3171 16.9993 15.4755V7.8567C16.9993 7.01515 16.3171 6.33294 15.4756 6.33294Z",
    fill: "#4F46E5",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04722 11.6663H2.52346C2.11933 11.6663 1.73176 11.5058 1.446 11.22C1.16023 10.9343 0.999696 10.5467 0.999696 10.1426V6.33316V2.52376C0.999696 2.11963 1.16023 1.73206 1.446 1.4463C1.73176 1.16054 2.11933 1 2.52346 1H6.33286H10.1423C10.5464 1 10.934 1.16054 11.2197 1.4463C11.5055 1.73206 11.666 2.11963 11.666 2.52376V4.04752",
    stroke: "#4F46E5",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPacketLoss);
export default __webpack_public_path__ + "static/media/icon_packet_loss.e49cf315099b1f572015d9cbb307a17b.svg";
export { ForwardRef as ReactComponent };